import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Container, Row, Col } from '@swift-paypal/pp-react';
import OtpFormComponent from '../components/otp/otp-form';
import { generateOtpAction, verifyOtpAction, resendOtpAction } from '../redux/actions/auth/auth-actions';
import AnonymousPage from '../hocs/anonymous-page';
import PageTitle from '../components/common/page-title';
import displayNames from '../constants/displayNames';
import StandardLayout from '../layouts/StandardLayout';

const OtpPage = ({
  country,
  error,
  generated,
  generateOtp,
  history,
  loading,
  rateLimited,
  resendLoading,
  resendOtp,
  resendSuccess,
  successMessage,
  verifyLoading,
  verifyOtp,
}) => {
  useEffect(() => {
    generateOtp({ country, history });
  }, []);

  const submit = useCallback((values) => {
    verifyOtp({ otp: values.otp, country, history });
  }, [verifyOtp, country, history]);

  const handleResend = useCallback(() => {
    resendOtp({ country, history });
  }, [resendOtp, country, history]);

  return (
    <Container className="security-container">
      <Helmet>
        <title>Verify OTP</title>
      </Helmet>
      <StandardLayout
        contentElement={(
          <Row className="security-container">
            <Col>
              <PageTitle text="Verify Your Identity" />
              <p className="margin-bottom-sm">Enter the 6-digit code sent to your email</p>
              {generated && (
                <OtpFormComponent
                  onSubmit={submit}
                  onResend={handleResend}
                  otpError={error}
                  loading={loading}
                  verifyLoading={verifyLoading}
                  resendLoading={resendLoading}
                  rateLimited={rateLimited}
                  resendSuccess={resendSuccess}
                  successMessage={successMessage}
                />
              )}
            </Col>
          </Row>
        )}
        sidebarElement={<></>}
      />
    </Container>
  );
};

OtpPage.displayName = displayNames.OtpPage;

OtpPage.propTypes = {
  country: PropTypes.string,
  error: PropTypes.string,
  generated: PropTypes.bool,
  generateOtp: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  loading: PropTypes.bool,
  rateLimited: PropTypes.bool,
  resendLoading: PropTypes.bool,
  resendOtp: PropTypes.func.isRequired,
  resendSuccess: PropTypes.bool,
  successMessage: PropTypes.string,
  verifyLoading: PropTypes.bool,
  verifyOtp: PropTypes.func.isRequired,
};

OtpPage.defaultProps = {
  country: undefined,
  error: undefined,
  generated: false,
  loading: false,
  rateLimited: false,
  resendLoading: false,
  resendSuccess: false,
  successMessage: undefined,
  verifyLoading: false,
};

function mapStateToProps(state) {
  return {
    error: state.otp.error,
    generated: state.otp.generated,
    loading: state.otp.loading,
    verifyLoading: state.otp.verifyLoading,
    resendLoading: state.otp.resendLoading,
    rateLimited: state.otp.rateLimited,
    resendSuccess: state.otp.resendSuccess,
    successMessage: state.otp.message,
  };
}

export default connect(
  mapStateToProps,
  {
    generateOtp: generateOtpAction,
    verifyOtp: verifyOtpAction,
    resendOtp: resendOtpAction,
  },
)(AnonymousPage(OtpPage));
